document.addEventListener('DOMContentLoaded', function () {
  var noteToggle = document.getElementById('CartDrawer-NoteToggle');
  var notePanel = document.getElementById('CartDrawer-NotePanel');
  var discountToggle = document.getElementById('CartDrawer-DiscountToggle');
  var discountPanel = document.getElementById('CartDrawer-DiscountPanel');
  var discountApply = document.getElementById('CartDrawer-Discount-Apply');
  var discountInput = document.getElementById('CartDrawer-Discount-Custom');

  function togglePanel(panel, otherPanel) {
    if (!panel) return;
    var isHidden = panel.hasAttribute('hidden');
    if (otherPanel) otherPanel.setAttribute('hidden', '');
    if (isHidden) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  if (noteToggle) {
    noteToggle.addEventListener('click', function () {
      togglePanel(notePanel, discountPanel);
    });
  }
  if (discountToggle) {
    discountToggle.addEventListener('click', function () {
      togglePanel(discountPanel, notePanel);
    });
  }
  if (discountApply) {
    discountApply.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }
});